"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDrawingParameterJsonSchema = exports.IDrawingParameterVisualizationSettingsJsonSchema = exports.validateDrawingParameterSettings = void 0;
const zod_1 = require("zod");
const validateDrawingParameterSettings = (param) => {
    return exports.IDrawingParameterJsonSchema.safeParse(param);
};
exports.validateDrawingParameterSettings = validateDrawingParameterSettings;
const optionalBoolean = zod_1.z.preprocess((val) => {
    if (val === "true")
        return true;
    if (val === "false")
        return false;
    if (val === null)
        return undefined;
    return val;
}, zod_1.z.boolean().optional());
exports.IDrawingParameterVisualizationSettingsJsonSchema = zod_1.z
    .object({
    distanceLabels: optionalBoolean,
    pointLabels: optionalBoolean,
    pointerPosition: optionalBoolean,
    distanceMultiplicationFactor: zod_1.z.number().nullable().optional(),
    lines: zod_1.z.any().nullable().optional(),
    points: zod_1.z.any().nullable().optional(),
    wireframe: optionalBoolean,
    wireframeColor: zod_1.z.string().nullable().optional(),
    edgeControlVisualization: zod_1.z
        .object({
        lines: zod_1.z.any().nullable().optional(),
        points: zod_1.z.any().nullable().optional(),
    })
        .nullable()
        .optional(),
})
    .nullable()
    .optional();
const stringOrStringArray = zod_1.z
    .union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())])
    .optional();
exports.IDrawingParameterJsonSchema = zod_1.z.object({
    controls: zod_1.z.array(zod_1.z.any()).nullable().optional(),
    geometry: zod_1.z
        .object({
        mode: zod_1.z.enum(["points", "lines"]),
        minPoints: zod_1.z.number().nullable().optional(),
        maxPoints: zod_1.z.number().nullable().optional(),
        strictMinMaxPoints: optionalBoolean,
        close: optionalBoolean,
        autoClose: optionalBoolean,
        weightedAdjacency: zod_1.z
            .array(zod_1.z.array(zod_1.z.object({
            to: zod_1.z.number(),
            weights: zod_1.z.tuple([
                zod_1.z.number(),
                zod_1.z.number(),
                zod_1.z.number(),
            ]),
        })))
            .nullable()
            .optional(),
        disabledPoints: zod_1.z.array(zod_1.z.number()).nullable().optional(),
        constraints: zod_1.z
            .object({
            position: zod_1.z
                .object({
                x: zod_1.z
                    .tuple([zod_1.z.number(), zod_1.z.number()])
                    .nullable()
                    .optional(),
                y: zod_1.z
                    .tuple([zod_1.z.number(), zod_1.z.number()])
                    .nullable()
                    .optional(),
                z: zod_1.z
                    .tuple([zod_1.z.number(), zod_1.z.number()])
                    .nullable()
                    .optional(),
            })
                .nullable()
                .optional(),
            size: zod_1.z
                .object({
                x: zod_1.z
                    .tuple([zod_1.z.number(), zod_1.z.number()])
                    .nullable()
                    .optional(),
                y: zod_1.z
                    .tuple([zod_1.z.number(), zod_1.z.number()])
                    .nullable()
                    .optional(),
                z: zod_1.z
                    .tuple([zod_1.z.number(), zod_1.z.number()])
                    .nullable()
                    .optional(),
            })
                .nullable()
                .optional(),
        })
            .nullable()
            .optional(),
    })
        .nullable()
        .optional(),
    restrictions: zod_1.z.array(zod_1.z.any()).nullable().optional(),
    general: zod_1.z
        .object({
        prompt: zod_1.z
            .object({
            inactiveTitle: zod_1.z.string().nullable().optional(),
            activeTitle: zod_1.z.string().nullable().optional(),
            activeText: zod_1.z.string().nullable().optional(),
        })
            .nullable()
            .optional(),
        options: zod_1.z
            .object({
            showDistanceLabels: optionalBoolean,
            showPointLabels: optionalBoolean,
            showPointerPosition: optionalBoolean,
            snapToVertices: optionalBoolean,
            snapToEdges: optionalBoolean,
            snapToFaces: optionalBoolean,
        })
            .nullable()
            .optional(),
        activeMode: zod_1.z.enum(["default", "activeOnStart"]).optional(),
    })
        .nullable()
        .optional(),
    behavior: zod_1.z
        .object({
        displayUnit: zod_1.z.string().nullable().optional(),
        enableTranslation: optionalBoolean,
        enableInsertion: optionalBoolean,
        enableDeletion: optionalBoolean,
        enableSelection: optionalBoolean,
    })
        .nullable()
        .optional(),
    keyBindings: zod_1.z
        .object({
        insert: stringOrStringArray,
        delete: stringOrStringArray,
        confirm: stringOrStringArray,
        cancel: stringOrStringArray,
        undo: stringOrStringArray,
        redo: stringOrStringArray,
    })
        .nullable()
        .optional(),
    visualization: exports.IDrawingParameterVisualizationSettingsJsonSchema,
});
//# sourceMappingURL=IDrawingParametersSettings.js.map